import { Inspection } from "../types/inspections/Inspection";
import { AmplifyUser } from "@aws-amplify/ui";
import axios from "axios";
import { getHeader } from "./user";
import { OrganisationInfo } from "../types/inspections/OrganisationInfo";

export interface GetInspectionsRequestData {
    orgIds: string[],
    user: AmplifyUser,
    status?: number[]
}

export const getInspectionsByOrgId = async (requestData: GetInspectionsRequestData): Promise<Inspection[]> => {
    const url = process.env.REACT_APP_IDWAL_API_URL + "/CustomerPortal/Inspections";
    let inspectionData: Inspection[] = [];

    try {
        const token = requestData.user.getSignInUserSession()?.getIdToken();
        if (!token) {
            return Promise.reject("No token");
        }

        const header = await getHeader();

        const result = await axios.post(
            url, 
            {
                orgIds: requestData.orgIds,
                status: requestData.status,
                page: 1,
                dateStart: "",
                dateEnd: ""
            },
            { 
                headers: header 
            }
        );
        if (!result.data || result.data.length === 0) {
            return Promise.reject("No data");
        }

        inspectionData = result.data;
        return Promise.resolve(inspectionData);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const getOrganisationsInfoAsync = async (orgIds: string[]): Promise<OrganisationInfo[]> => {
    if (orgIds.length === 0) {
        return Promise.reject("No orgIds for organisations info request.");
    }

    const url = process.env.REACT_APP_IDWAL_API_URL + "/CustomerPortal/OrganisationsInfo";
    let organisationsInfo: OrganisationInfo[] = [];

    try {
        const header = await getHeader();
        const result = await axios.post(url, {orgIds: orgIds}, { headers: header });
        if (!result.data || result.data.length === 0) {
            return Promise.reject("No organisations info found");
        }

        organisationsInfo = result.data;
        organisationsInfo.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        return Promise.resolve(organisationsInfo);
    } catch (error) {
        return Promise.reject(error);
    }
}
